webpackJsonp([18],{

/***/ 873:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__maptypes__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__maptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__maptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chartTypes__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chartTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__chartTypes__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'compare-section',
  props: ['relativeIndicatorsValues', 'singleMapSource', 'selectedIndicator', 'compType', 'dataSources', 'comparismType', 'regionalChartYearOptionsData', 'optionIndicators', 'relativeIndicators', 'appData', 'selectedState'],
  components: {
    PlotMap: __WEBPACK_IMPORTED_MODULE_0__maptypes___default.a, PlotChart: __WEBPACK_IMPORTED_MODULE_1__chartTypes___default.a
  },
  data: function data() {
    return {
      // componentType: "Charts",
      specificComponentOptions: ["line", "column"],
      specificComponentType: "line",
      component: 'line',
      indicatorForMapAndChart: [],
      componentType: ['Map', 'Map', 'Map'],
      specificMapType: ['states', 'states', 'states'],
      specificChartType: ['line', 'line', 'line'],
      selectedYear: null,
      lsData: JSON.parse(this.$ls.get('car_other_dataset')),
      expandedBoolVal: [false, false, false],
      compareSectionKey: '',
      // sourceSelected: '',
      compareSectionIndicatorValue: '',
      expandedView: false,
      multiselectIndicator: ['', '', ''],
      sourcesSelected: ['', '', '']
    };
  },

  methods: {
    dropdownChangedChart: function dropdownChangedChart(value, key) {
      this.specificChartType[key] = value;
    },
    expandedBool: function expandedBool(indicator_value, key) {
      this.expandedBoolVal.splice(key, 1, true);
      this.compareSectionKey = key;
      this.compareSectionIndicatorValue = indicator_value;
      this.expandedView = true;
    },
    closeExpandedBool: function closeExpandedBool(val) {
      //this.expandedBoolVal[val] = !this.expandedBoolVal[val];
      this.expandedBoolVal = [false, false, false];
      this.expandedView = false;
    },
    changeExpandedBoolVal: function changeExpandedBoolVal(key) {
      this.expandedBoolVal.splice(key, 1, false);
    },
    computeIndicatorSelected: function computeIndicatorSelected(key, e) {
      this.indicatorForMapAndChart[key] = e;
    },
    indicatorMultiselectChanged: function indicatorMultiselectChanged(key, e) {
      this.multiselectIndicator.splice(key, 1, e);
    },
    sourceMultiselectChanged: function sourceMultiselectChanged(key, e) {
      this.sourcesSelected.splice(key, 1, e);
      // this.sourceSelected = e;
    },

    /** Changes the component type using slice
     * (simply modifying will not trigger the watch on the child component)
    */
    changeComponent: function changeComponent(type, key) {
      this.specificComponentType = type;
      if (type === 'zones' || type === 'states') {
        // this.componentType[key] = 'Map';
        //console.log(key)
        this.componentType.splice(key, 1, 'Map');
        this.specificMapType[key] = type;
      } else {
        // this.componentType[key] = 'Charts';
        this.componentType.splice(key, 1, 'Charts');
        this.specificChartType[key] = type;
      }
      this.$emit('componentTypeArray', this.componentType);
    },
    dropdownChangedMap: function dropdownChangedMap(value, key) {
      this.specificMapType[key] = value;
      // this.specificMapType = value
    },
    compareSectionClicked: function compareSectionClicked() {
      //Event listener to change background color of clicked div
      // console.log("This won't be styled: " + '%c' + "Yay i was called", 'color: red; font-weight: bold; background-color: yellow; padding: 10px;')
      var sections = document.querySelectorAll('.comparison-options');
      if (sections.length > 0) {
        var section1 = [],
            section2 = [],
            section3 = [];
        for (var i in sections) {
          if (i < 5) {
            section1.push(sections[i]);
          } else if (i > 4 && i < 10) {
            section2.push(sections[i]);
          } else if (i > 9 && i < sections.length) {
            section3.push(sections[i]);
          }
        }
        sections.forEach(function (section, index) {
          section.addEventListener('click', function () {
            if (index < 5) {
              section1.forEach(function (el) {
                if (el.className.indexOf(' compare-option-selected') > 0) {
                  el.className = el.className.replace(' compare-option-selected', '');
                }
              });
            } else if (index > 4 && index < 10) {
              section2.forEach(function (el) {
                if (el.className.indexOf(' compare-option-selected') > 0) {
                  el.className = el.className.replace(' compare-option-selected', '');
                }
              });
            } else if (index > 9 && index < sections.length) {
              section3.forEach(function (el) {
                if (el.className.indexOf(' compare-option-selected') > 0) {
                  el.className = el.className.replace(' compare-option-selected', '');
                }
              });
            }
            section.className += ' compare-option-selected';
          });
        });
      }
    }
  },
  mounted: function mounted() {
    if (this.appData) {
      this.lsData = this.appData;
    }
    //console.log(this.relativeIndicatorsValues);

    this.indicatorForMapAndChart = this.relativeIndicators;
  },

  computed: {
    /**
     * Get the source clicked/checked on the table
     *@param none
     *@returns sourceclicked | indicatorSource: String
     */
    // sourceClicked() {
    //   var tableColumnHeaderAttr = this.$store.getters.getSourceClicked;
    //   var sources = tableColumnHeaderAttr[0];
    //   var val = tableColumnHeaderAttr[1];var stateByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
    //   var indicatorSource = this.selectedIndicator + " -> " + sources;
    //   if(this.lsData){
    //     var indexOfindicatorSource = this.lsData[0].indexOf(indicatorSource) - 1;
    //     // check for availability of data in the source here
    //     var defaultSource = this.$store.getters.getDefaultSource;
    //     var selectedSource = defaultSource; //statesWithIndicatorsYearAndValues[1] > 0 ? sources:
    //     let data = this.lsData.slice(1);
    //     for(var i in data){
    //         if(data[i][indexOfindicatorSource] !== "" && indexOfindicatorSource > 0){
    //           selectedSource = sources;
    //           break;
    //         } else {
    //           selectedSource = defaultSource;
    //           continue;
    //         }
    //     }
    //     // get the state indicator source object from store
    //     var stateSelectedIndicatorSource = this.$store.getters.getSelectedIndicatorSource;
    //     var selectedIndicatorSource = stateSelectedIndicatorSource[selectedSource];

    //     if (selectedIndicatorSource) {
    //       // compute the years custom to the data
    //       var optionYear = [];
    //       Object.keys(stateSelectedIndicatorSource).map( (elem, index) => {
    //           if (stateSelectedIndicatorSource[elem].length > 0) {
    //               optionYear.push(stateSelectedIndicatorSource[elem][0])
    //           }
    //       })
    //       //this.optionYear = optionYear; // assign to select year field
    //       // get the indicator selected, and watch the year of its current value.
    //       if (selectedIndicatorSource.length > 0) {
    //         this.selectedYear = selectedIndicatorSource[0];
    //       }
    //     }
    //     return selectedSource;
    //   }
    // }
  },
  updated: function updated() {
    // Method call for event listener 
    this.compareSectionClicked();
  },

  watch: {
    selectedIndicator: function selectedIndicator(val) {
      //console.log(val);
    },
    relativeIndicators: function relativeIndicators(val) {
      //console.log(val);
      this.indicatorForMapAndChart = val;
    },

    // specificComponentType(val){
    //   if(val === 'line' || val === 'column'){
    //    this.componentType = 'Charts'
    //   } else {
    //     this.componentType = 'Map'
    //   }
    //   console.log(this.componentType)
    // },
    componentType: function componentType(val) {
      if (val === "Map") {
        this.specificComponentOptions = ["states", "zones"];
        this.specificComponentType = "states";
      } else {
        this.specificComponentOptions = ["line", "column"];
        this.specificComponentType = "line";
      }
    },
    appData: function appData(val) {
      if (val) {
        this.lsData = val;
      }
    },
    compType: function compType(val) {}
  }
});

/***/ }),

/***/ 944:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(873),
  /* template */
  __webpack_require__(968),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 968:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', _vm._l((_vm.relativeIndicatorsValues), function(indicator_value, key) {
    return _c('div', {
      key: key,
      staticClass: "col-xs-12 col-md-4 compare-indicators",
      staticStyle: {
        "margin-top": "2px"
      }
    }, [_c('div', {
      staticClass: "panel panel-primary widget",
      attrs: {
        "id": 'widget_' + key
      }
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('div', {
      staticClass: "row compare-panel-switch"
    }, [_c('div', {
      staticClass: "col-xs-2 comparison-options",
      on: {
        "click": function($event) {
          _vm.expandedBool(indicator_value, key)
        }
      }
    }, [_c('span', {}, [_vm._v("EXPAND")]), _vm._v(" "), _c('v-icon', [_vm._v("zoom_out_map")])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-offset-2 col-xs-2 comparison-options",
      on: {
        "click": function($event) {
          _vm.changeComponent('zones', key)
        }
      }
    }, [_c('span', {}, [_vm._v("ZONES MAP")]), _vm._v(" "), _c('v-icon', [_vm._v("fas fa-map-marker")])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 comparison-options compare-option-selected",
      on: {
        "click": function($event) {
          _vm.changeComponent('states', key)
        }
      }
    }, [_c('span', {}, [_vm._v("STATES MAP")]), _vm._v(" "), _c('v-icon', [_vm._v("fas fa-map-marker")])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 comparison-options",
      on: {
        "click": function($event) {
          _vm.changeComponent('line', key)
        }
      }
    }, [_c('span', {}, [_vm._v("LINE CHART")]), _vm._v(" "), _c('v-icon', [_vm._v("show_chart")])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 comparison-options",
      on: {
        "click": function($event) {
          _vm.changeComponent('column', key)
        }
      }
    }, [_c('span', {}, [_vm._v("COLUMN CHART")]), _vm._v(" "), _c('v-icon', [_vm._v("bar_chart")])], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "row panel-body"
    }, [_c('plot-map', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.componentType[key] === 'Map'),
        expression: "componentType[key]==='Map'"
      }],
      attrs: {
        "masterIndicator": _vm.selectedIndicator,
        "relativeIndicator": _vm.relativeIndicators[key],
        "indicatorOptions": _vm.optionIndicators,
        "appData": _vm.appData,
        "mapType": _vm.specificMapType[key],
        "isExpanded": _vm.expandedBoolVal[key],
        "indicatorClicked": _vm.multiselectIndicator[key],
        "sourceSelected": _vm.sourcesSelected[key]
      },
      on: {
        "expanded": function($event) {
          _vm.changeExpandedBoolVal(key)
        },
        "indicatorClicked": function($event) {
          _vm.indicatorMultiselectChanged(key, $event)
        },
        "sourceSelected": function($event) {
          _vm.sourceMultiselectChanged(key, $event)
        }
      }
    }), _vm._v(" "), _c('plot-chart', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.componentType[key] === 'Charts'),
        expression: "componentType[key]==='Charts'"
      }],
      attrs: {
        "masterIndicator": _vm.selectedIndicator,
        "relativeIndicator": _vm.relativeIndicators[key],
        "indicatorOptions": _vm.optionIndicators,
        "appData": _vm.appData,
        "selectedState": _vm.selectedState,
        "isExpanded": _vm.expandedBoolVal[key],
        "chartType": _vm.specificChartType[key],
        "indicatorClicked": _vm.multiselectIndicator[key],
        "sourceSelected": _vm.sourcesSelected[key]
      },
      on: {
        "expanded": function($event) {
          _vm.changeExpandedBoolVal(key)
        },
        "indicatorClicked": function($event) {
          _vm.indicatorMultiselectChanged(key, $event)
        },
        "sourceSelected": function($event) {
          _vm.sourceMultiselectChanged(key, $event)
        }
      }
    })], 1)])])
  }))
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/18.76054d5cb0ff7c0499a1.js